import moment from 'moment';

export const formatDate = (time: string) => moment(time).format('MMM D, YYYY-h:mm A').split('-');
